import { tw } from "@careinfo/tailwind";
import { useFormContext } from "react-hook-form";
import TextField from "../../shared/TextField";
import { IPopup } from "../../types/interface";

export default function PageForm() {
  const { control } = useFormContext<IPopup>();

  return (
    <div className={tw`grid grid-cols-2 gap-4`}>
      <TextField
        control={control}
        name="title"
        placeholder="Enter title of page"
        label="Title"
      />
      <TextField
        control={control}
        name="description"
        placeholder="Enter Description for page"
        label="Description"
      />
    </div>
  );
}
